import request from '@/utils/request'

// 查询列表
export function apiInvGetWmsStockQtyList (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsStockQtyList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiInvOnhandQuantitiesNewExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsStockQtyExport',
    method: 'post',
    data: data
  })
}
